export default __webpack_public_path__ + "fcb4c0582bbc9a8cea3d48fd0e80c27e.png";